import { v4 as uuidv4 } from 'uuid';

export const uniqueId = function (prefix) {
  return `${prefix}${uuidv4()}`;
};

export default {
  uniqueId
};
